export default __webpack_public_path__ + "img/rule_4-d1a679a7.png";